import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '~/app/store'
import { isJsonString } from '~/utils'

export interface ILocaleSetting {
  timezone: string
  locale: string
}

const initialState: ILocaleSetting = isJsonString(
  localStorage.getItem('localeSetting') as string
)
  ? JSON.parse(localStorage.getItem('localeSetting') as string)
  : {
      timezone: 'UTC'
    }

const SettingSlice = createSlice({
  name: 'localSetting',
  initialState,
  reducers: {
    setLocaleSetting: (state, action: PayloadAction<ILocaleSetting>) => {
      state.timezone = action.payload.timezone
      state.locale = action.payload.locale

      localStorage.setItem('localeSetting', JSON.stringify(state))
    }
  }
})

export const localeSetting = (state: RootState) => state.localSetting
export const setLocaleSetting = SettingSlice.actions.setLocaleSetting

export default SettingSlice.reducer
